import axios from "@/axios.js";
import axiosNotAuth from "axios";

const RESOURCE_URL = "/participants/";

export default {
  add({ commit }, { participant }) {
    return new Promise((resolve, reject) => {
      axios
        .post(RESOURCE_URL, participant)
        .then((response) => {
          commit(
            "ADD_PARTICIPANT",
            // Flatch Earth,
            Object.assign(participant, {
              id: response.data.id,
              neighborhoodsServed: response.data.neighborhoodsServed,
            })
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchParticipantById({ commit }, { recordId }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${RESOURCE_URL}${recordId}`)
        .then((response) => {
          commit("SET_PARTICIPANT", response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchParticipants({ commit }, { limit, offset, order, filters }) {
    order = order || { name: "asc" };
    const orderBy = Object.getOwnPropertyNames({ ...order })[0];
    const orderType = order[orderBy];

    let params = `limit=${limit}&offset=${offset}&orderBy=${orderBy}&orderType=${orderType}`;
    if (filters) {
      const fields = Object.keys(filters);
      fields.forEach((field) => {
        params += `&${field}=${filters[field]}`;
      });
    }

    return new Promise((resolve, reject) => {
      axios
        .get(`caravanists${RESOURCE_URL}?${params}`)
        .then((response) => {
          if (offset === 0) {
            commit("CLEAR_PARTICIPANTS");
          }
          commit("SET_PARTICIPANTS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update({ commit }, participant) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${RESOURCE_URL}${participant.id}`, participant)
        .then((response) => {
          commit("UPDATE_PARTICIPANT", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  removeFromCaravanist({ commit }, participantId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/caravanists${RESOURCE_URL}${participantId}`)
        .then((response) => {
          commit("REMOVE_PARTICIPANT", participantId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  exists({ commit }, { cpf, uuid }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${RESOURCE_URL}exists/${cpf}`)
        .then((response) => {
          commit("EXISTING_PARTICIPANT", {
            uuid,
            response,
          });
          resolve(response.data);
        })
        .catch((err) => {
          if (err && err.response) {
            const { errors } = err.response.data;
            errors.forEach((error) => {
              if (error.message) {
                if (error.message.indexOf("não encontrado")) {
                  resolve(false);
                  commit("EXISTING_PARTICIPANT", {
                    uuid,
                    response: {},
                  });
                }
              }
            });
          }

          reject(err);
        });
    });
  },
  reset({ commit }, data) {
    commit("EXISTING_PARTICIPANT", {});
  },
  associate({ commit }, data) {
    const payload = {
      caravanist: data.caravanist,
    };

    return new Promise((resolve, reject) => {
      axios
        .post(`${RESOURCE_URL}${data.id}/caravanists/`, payload)
        .then((response) => {
          commit("ASSOCIATE_PARTICIPANT", response);
          resolve(response);
        })
        .catch((err) => {
          if (err && err.response) {
            const { errors } = err.response.data;
            errors.forEach((error) => {
              if (error.message) {
                if (error.message.indexOf("'Caravanista' duplicado")) {
                  resolve(false);
                  commit("EXISTING_PARTICIPANT", {});
                }
              }
            });
          }

          reject(err);
        });
    });
  },
  requestSMSCode({ commit }, id) {
    const payload = {
      id,
    };
    return new Promise((resolve, reject) => {
      axios
        .post(`${RESOURCE_URL}sms`, payload)
        .then((response) => {
          commit("SMS_REQUESTED", response);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  requestSMSCodeCreate({ commit }, mobile) {
    const payload = {
      id: 1,
      newParticipant: true,
      mobile: mobile,
    };
    return new Promise((resolve, reject) => {
      axios
        .post(`${RESOURCE_URL}sms`, payload)
        .then((response) => {
          commit("SMS_REQUESTED_CREATE", response);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  confirmSMSCreate({ commit }, data) {
    const payload = {
      mobile: data.mobile,
      code: data.code,
    };
    return new Promise((resolve, reject) => {
      axios
        .post(`${RESOURCE_URL}code`, payload)
        .then((response) => {
          commit("CONFIRM_SMS", response.data);
          // commit('UPDATE_PARTICIPANT', response.data.participant)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  generateToken({ commit }, data) {
    const payload = {
      id: data.id,
      code: data.code,
    };
    return new Promise((resolve, reject) => {
      axios
        .post(`${RESOURCE_URL}tokens`, payload)
        .then((response) => {
          commit("TOKEN_GENERATED", response.data.token);
          // commit('UPDATE_PARTICIPANT', response.data.participant)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateProfile({ commit }, { participant, token }) {
    const baseUrl = process.env.VUE_APP_API_URL;
    const config = {
      headers: {
        Authorization: token,
      },
    };
    return new Promise((resolve, reject) => {
      axiosNotAuth
        .patch(`${baseUrl}participants/participant`, participant, config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePhoto({ commit }, { photo, token }) {
    const baseUrl = process.env.VUE_APP_API_URL;
    const config = {
      headers: {
        authorization: token,
      },
    };

    return new Promise((resolve, reject) => {
      axiosNotAuth
        .post(
          `${baseUrl}upload/image/participant`,
          {
            base64: photo,
            reference: 1,
            type: `participant`,
          },
          config
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePhotoByAdmin({ commit }, { base64, participantId }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/upload/image`, {
          base64,
          type: "participant",
          reference: participantId,
        })
        .then((res) => {
          if (res && res.data) {
            const { url } = res.data;
            if (url) {
              commit("SET_PARTICIPANT_PHOTO", url);
            }
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  removeParticipantData({ commit }, { token }) {
    const baseUrl = process.env.VUE_APP_API_URL;
    const config = {
      headers: {
        authorization: token,
      },
    };
    console.log("config", config);
    return new Promise((resolve, reject) => {
      axiosNotAuth
        .delete(`${baseUrl}participants`, config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
